import React, { useState } from "react";
import { WidgetProps } from "@rjsf/utils";
import MediaField from "./MediaField";
import uploadFile from "../api/uploadFile";
import { key } from "../api/useGetImages";
import { useQueryClient } from "react-query";
import GeneratorPicker from "./GeneratorPicker/GeneratorPicker";

const ImageUrlWidget: React.FC<WidgetProps & { title?: string }> = props => {
  const { onChange, schema, value } = props;
  const { title } = schema;
  const [showGeneratorPicker, setShowGeneratorPicker] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const id = props.id;

  const handleUploadClick = () => {
    document.getElementById("svg-file-uploader_" + id)?.click();
  };

  const handleGeneratorClick = () => {
    setShowGeneratorPicker(!showGeneratorPicker);
  };

  const handleFileChanged = async (file: File) => {
    setLoading(true);
    try {
      const url = await uploadFile(file);
      onChange(url);
      queryClient.invalidateQueries(key);
      setShowGeneratorPicker(false);
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setLoading(false);
    }
  };

  const queryClient = useQueryClient();
  return (
    <>
      <input
        id={"svg-file-uploader_" + id}
        type="file"
        accept="image/*"
        onChange={async e => {
          const file = e.target.files?.[0];
          if (file) {
            setLoading(true);
            try {
              const url = await uploadFile(file);
              onChange(url);
              queryClient.invalidateQueries(key);
            } catch (error) {
              console.error("Error uploading file:", error);
            } finally {
              setLoading(false);
            }
          }
        }}
        style={{ display: "none" }}
      />

      <MediaField
        title={title}
        value={value}
        onValueChange={onChange}
        onUploadClicked={handleUploadClick}
        onGeneratorClicked={handleGeneratorClick}
        loading={loading}
      >
        {showGeneratorPicker && (
          <div style={{ marginBottom: "16px" }}>
            <GeneratorPicker fieldId={id} onFileChanged={handleFileChanged} currentImageUrl={value} />
          </div>
        )}
      </MediaField>
    </>
  );
};

export default ImageUrlWidget;
